'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArrowButtonDown2 = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.468 2.984a2 2 0 0 0-1.742-1.018H2.274A2 2 0 0 0 .563 5l9.726 16.07a2 2 0 0 0 3.422 0L23.437 5a2 2 0 0 0 .031-2.016z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12.043 21.535a1.498 1.498 0 0 1-1.281-.724L1.038 4.742A1.502 1.502 0 0 1 2.32 2.467h19.453a1.502 1.502 0 0 1 1.283 2.275l-9.728 16.069a1.492 1.492 0 0 1-1.285.724zM2.322 3.467a.5.5 0 0 0-.427.758l9.724 16.069a.506.506 0 0 0 .548.227.496.496 0 0 0 .308-.227L22.2 4.225a.5.5 0 0 0-.428-.758H2.322z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12.002 22.25a1.481 1.481 0 0 1-1.294-.76L.948 4.245A1.503 1.503 0 0 1 2.225 2h19.539c.265.004.518.074.738.201.347.2.595.524.699.911.104.387.05.791-.15 1.138l-9.759 17.242a1.473 1.473 0 0 1-.571.569 1.471 1.471 0 0 1-.719.189zm.014-1.495zm-.015-.027l9.747-17.222L2.253 3.5l9.748 17.228z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowButtonDown2.displayName = 'IconArrowButtonDown2';
exports.default = IconArrowButtonDown2;